// extracted by mini-css-extract-plugin
export default {"simpleFooterLink":"daodao-brand-footer-SimpleLinkSection__simpleFooterLink--1M0Bl"};